import { render, staticRenderFns } from "./CreateDependentListsModal.vue?vue&type=template&id=5c085782&scoped=true"
import script from "./CreateDependentListsModal.vue?vue&type=script&lang=js"
export * from "./CreateDependentListsModal.vue?vue&type=script&lang=js"
import style0 from "./CreateDependentListsModal.vue?vue&type=style&index=0&id=5c085782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c085782",
  null
  
)

export default component.exports